<!-- Selector de imagen tipo drop-area (ui-redesign): arrastrar o clic + preview. -->
<div class="img-up">
	<input
		type="file"
		#fileInput
		[accept]="acceptedFormats.join(',')"
		(change)="onFileSelected($event)"
		hidden
	/>

	<!-- Sin imagen: zona para arrastrar / hacer clic -->
	<div
		*ngIf="!previewUrl"
		class="iu-drop"
		[class.dragging]="isDragging"
		[class.disabled]="disabled"
		(click)="openFileSelector()"
		(dragover)="onDragOver($event)"
		(dragleave)="onDragLeave($event)"
		(drop)="onDrop($event)"
	>
		<span class="iu-ic"><mat-icon>{{ isLoading ? "hourglass_top" : "add_photo_alternate" }}</mat-icon></span>
		<b class="iu-title">{{ dropLabel }}</b>
		<span class="iu-hint">{{ hint }}</span>
	</div>

	<!-- Con imagen: preview + acciones -->
	<div
		*ngIf="previewUrl"
		class="iu-preview"
		[class.dragging]="isDragging"
		(dragover)="onDragOver($event)"
		(dragleave)="onDragLeave($event)"
		(drop)="onDrop($event)"
	>
		<img [src]="previewUrl" alt="{{ fileName }}" (click)="showImagePreview()" />
		<div class="iu-actions" *ngIf="!disabled">
			<button type="button" class="iu-btn" (click)="openFileSelector()" [attr.aria-label]="'Cambiar imagen'"><mat-icon>edit</mat-icon></button>
			<button type="button" class="iu-btn danger" (click)="clearSelection()" [attr.aria-label]="'Quitar imagen'"><mat-icon>delete</mat-icon></button>
		</div>
		<div class="iu-meta" *ngIf="fileName">{{ fileName }}<span *ngIf="fileSize"> · {{ fileSize }}</span></div>
	</div>

	<p class="iu-error" *ngIf="errorMessage">{{ errorMessage }}</p>
</div>
